<table class="irb-pick-list">
  <tr>
    <td>
      <div>
        <input type="text" pInputText placeholder="Search..." [(ngModel)]="filterText" style="width: calc(100% - 23px); float: left" (keyup)="applyFilter()">
        <div class="left" style="width: 23px; height: 23px; background-color: #A6A6A6; cursor: pointer;" (click)="clearFilter()">
          <fa-icon [icon]="faTimes" style="color: white; margin: 0 6px; line-height: 23px;"></fa-icon>
        </div>
      </div>
      <br class="clear"/>
    </td>
  </tr>
  <tr>
    <td>
      <p-listbox [options]="sourceData" [(ngModel)]="sourceSelection" [multiple]="true"></p-listbox>
    </td>
    <td>
      <div class="block"><button class="btn-medium-secondary" (click)="onAdd()" [disabled]="!(sourceSelection.length > 0)">Add &gt;</button></div>
      @if (sourceData) {
        <div class="block"><button class="btn-medium-secondary" (click)="onAddAll()" [disabled]="sourceData.length == 0">Add all &gt;</button></div>
      }
      <!--div class="block"><button pButton label="&lt; Remove" (click)="onRemove()" calltoaction [calltoactionTemplate]="helloWorld"></button></div-->
      <div class="block">
        <div style="position: relative">
          <button class="btn-medium-secondary" [disabled]="!(targetSelection.length > 0)">&lt; Remove</button>
          @if (targetSelection.length > 0) {
            <div style="position: absolute; width: 100%; height: 100%; top: 0px; cursor: pointer;" calltoaction [calltoactionTemplate]="remove"></div>
          }
        </div>
      </div>
      <!--div class="block"><button pButton label="&lt; Remove all" (click)="onRemoveAll()"></button></div-->
      @if (targetData) {
        <div style="position: relative">
          <!-- <button class = "btn-medium-secondary" [disabled]="targetData.length == 0">&lt; Remove all</button>-->
          <button [disabled]="targetData.length == 0" style="width: 115px !important;" class="btn-medium-secondary">&lt; Remove all</button>
          @if (targetData.length > 0) {
            <div style="position: absolute; width: 100%; height: 100%; top: 0px; cursor: pointer;" calltoaction [calltoactionTemplate]="removeAll"></div>
          }
        </div>
      }
    </td>
    <td>
      <p-listbox [options]="targetData" [(ngModel)]="targetSelection" [multiple]="true"></p-listbox>
    </td>
  </tr>
</table>

<ng-template #remove>
  <div class="block"><strong>Remove these custom values?</strong></div>
  <div class="block">These custom values are assigned to some securities. Removing these values would leave the securities Uncategorized.</div>
  <div class="buttonSet">
    <button (click)="onCancel()" class="btn-medium-secondary">Cancel</button>
    <button (click)="onRemove()" class="btn-medium-primary">Remove</button>
  </div>
</ng-template>

<ng-template #removeAll>
  <div class="block"><strong>Remove these custom values?</strong></div>
  <div class="block">These custom values are assigned to some securities. Removing these values would leave the securities Uncategorized.</div>
  <div class="buttonSet">
    <button (click)="onCancel()" class="btn-medium-secondary">Cancel</button>
    <button (click)="onRemoveAll()" class="btn-medium-primary">Remove</button>
  </div>
</ng-template>
